<template>
    <div class="carousel" :class="{ 'carousel-simple': simple }">
        <div
            v-for="(data, i) in displayList"
            :key="i"
            class="item"
            @click="jump(data.url)"
        >
            <div>
                <img :src="data.poster" :alt="data.title">
            </div>
            <div>
                <h3>{{ data.title }}</h3>
            </div>
            <template v-if="!simple">
                <div>
                    {{ data.desc }}
                </div>
                <div class="column" @click.stop="jump(data.link)">
                    {{ data.column }}
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import doc from "@/documents/blogs.js"
export default {
    name: 'Carousel',
    props: {
        // 仅展示首图和标题
        simple: {
            type: Boolean,
            default: false,
        },
        // 只保留第一条
        limit: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            doc: doc,
        }
    },
    computed: {
        displayList() {
            const list = this.doc.bloglist['all'].slice(-4).reverse()
            if (this.limit > 0) {
                return list.slice(0, this.limit)
            }
            return list
        },
    },
    methods: {
        jump(link){
            if (!link) return
            window.location.href = link;
        }
    }
}
</script>
<style scoped lang="scss">
.carousel{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px 24px;
    margin-bottom: 30px;
}
.carousel-simple{
    grid-template-columns: repeat(4, 1fr);
    max-width: none;
    margin-left: 0;
    margin-right: 0;
}
.item{
    padding: 20px;
    background: #f8f8f8;
    border-radius: 8px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    &:hover{
        transform: translateY(-4px);
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    }
}
.column{
    margin-top: 30px;
    font-size: 15px;
    color: #0070c9;
    &:hover{
        color: rgb(0, 112, 201, 0.5);
    }
}
@media (max-width: 768px){
    .carousel{
        grid-template-columns: repeat(1, 1fr);
    }
}
</style>
